import React, { PureComponent } from 'react';
import styled from 'styled-components';
import COLORS from 'constants/colors';
import PropTypes from 'prop-types';

const StyledSpan = styled.span`
  font-size: 12px;
  color: ${COLORS.SKY};
  cursor: pointer;
  padding: 2px 4px;
`;

class ReadMoreButton extends PureComponent {
  static propTypes = {
    content: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      isReadMore: true,
    };
  }

  toggleReadMore = () => {
    const { isReadMore } = this.state;
    this.setState({ isReadMore: !isReadMore });
  };

  render() {
    const { content } = this.props;
    const { isReadMore } = this.state;
    const text = content;

    const ReadMoreText = () => {
      if (!text) {
        return null;
      }

      return (
        <div>
          {isReadMore ? `${text.slice(0, 70)}... ` : text}
          <StyledSpan onClick={this.toggleReadMore}>
            {isReadMore ? 'Read More' : ' Show Less'}
          </StyledSpan>
        </div>
      );
    };

    return ReadMoreText();
  }
}

export default ReadMoreButton;
